import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  PageContent,
  Container,
  Pagination,
  FiltersControls,
  BoxList,
  Spinner,
  Alerts,
} from 'components';
import {
  loadOrganisationCoursesCreator,
  setOrganisationCoursesPageCreator,
  setOrganisationCoursesPerPageCreator,
} from 'store/actionsCreators';
import { connect } from 'react-redux';
import { globalPropTypes, isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const Pending = ({ loading, loadList, setPage, setPerPage, list }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { items, page, pages, perPage } = list;

  useEffect(() => {
    setPage(1);
    loadList(id);
  }, [perPage]);

  return (
    <PageContent>
      <Container>
        {loading ? <Spinner /> : null}
        {!loading ? (
          <>
            <Alerts type="organisation" />
            <FiltersControls
              perPageSelected={perPage}
              perPageOnChange={(payload) => setPerPage(payload.value)}
            />
            <BoxList type="course" items={items} alert={t('global.noResultsCourses')} />
            <Pagination
              styled
              currentPage={page}
              totalPages={pages}
              onChange={(payload) => {
                setPage(payload);
                loadList(id);
              }}
            />
          </>
        ) : null}
      </Container>
    </PageContent>
  );
};

Pending.propTypes = {
  loading: PropTypes.bool,
  loadList: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  list: globalPropTypes.ListPropsTypes.isRequired,
};

Pending.defaultProps = {
  loading: false,
};

const mapStateToProps = ({
  loading,
  organisation: {
    courses: { pending: list },
  },
}) => ({
  loading: isLoading(loading, 'LOAD_ORGANISATION_COURSES_PENDING'),
  list,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: (organization) => dispatch(loadOrganisationCoursesCreator('pending', organization)),
  setPage: (payload) => dispatch(setOrganisationCoursesPageCreator('pending', payload)),
  setPerPage: (payload) => dispatch(setOrganisationCoursesPerPageCreator('pending', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Pending);
